import { useNavigate, useRouteError } from 'react-router'
import { ThemedErrorFallback } from './ThemedErrorFallback'

// Bridges React Router's route-level error handling with our ThemedErrorFallback UI.
// errorElement renders outside ProtectedRoute so FluentProvider is provided by ThemedErrorFallback.
export const RouterErrorBoundary = () => {
  const error = useRouteError()
  const navigate = useNavigate()
  return (
    <ThemedErrorFallback
      error={error instanceof Error ? error : new Error(String(error))}
      resetErrorBoundary={() => navigate('/', { replace: true })}
    />
  )
}
